import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { client } from "../../../../utils/axios-client";

export type ResponseItem = {
    id: string,
    original: string,
    suggested: string,
    reason: string,
    swapped: boolean
}

type Response = {
    sentances: ResponseItem[],
    finishReason: string
}

const useReviewer = (text: string, contentType: string) => {
    const queryClient = useQueryClient();
    const [isReviewing, setIsReviewing] = useState(true);
    const [result, setResult] = useState<ResponseItem[]>([]);

    useEffect(() => {
        if (!text || text.trim() === '' || text === '<p></p>') {
            setIsReviewing(false);
            return;
        }

        setIsReviewing(true);
        review();
    }, [text])

    const review = async () => {
        const res = await queryClient.fetchQuery<any>({
            queryKey: ['review-text'],
            queryFn: () => {
                return client.post<ResponseItem[]>(`/api/ai/chat/smart-review`,
                    {
                        contentType,
                        text
                    }).then((res) => res.data)
            },
        });

        setResult(res)
        setIsReviewing(false);
    }

    const toggleSwapped = (sectionToSwap: ResponseItem) => {
        const temp = structuredClone(result);

        const section = temp.find(s => s.id === sectionToSwap.id);

        if (section) {
            section.swapped = !section.swapped;
        }

        setResult(temp);
    }

    return { result, toggleSwapped, isReviewing }
}

export default useReviewer;